module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "block block-link-shadow text-center",
    attrs: {
      "to": {
        name: _vm.route
      }
    }
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c('i', {
    staticClass: "si fa-4x",
    class: ['si-' + _vm.icon, _vm.iconClass]
  })]), _vm._v(" "), _c('p', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-deba5090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/Tile.vue
// module id = 759
// module chunks = 1